import React from "react";

import StepLayout, { StepLayoutClassName } from "components/Step/StepLayout";

import LoadingAnimation from "@/atoms/LoadingAnimation";

export interface StepLayoutLoadingScreenProps {
  className?: string;
  message?: string;
}

export const StepLayoutLoadingScreen = ({
  className = "",
  message,
}: StepLayoutLoadingScreenProps) => {
  return (
    <StepLayout
      asForm={false}
      className={className}
      css={`
        .${StepLayoutClassName.CONTENT_SPACING} {
          justify-content: center;
        }
      `}
      stepFooterProps={{
        nextButtonProps: {
          disabled: true,
          style: {
            display: "none",
          },
        },
        suppressBackButton: true,
      }}
      stepHeaderProps={{ suppressBackButton: true }}
    >
      <LoadingAnimation inline message={message} />
    </StepLayout>
  );
};

export default StepLayoutLoadingScreen;
